<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="$refs.Form.save()"
        large
        ref="Modal"
        title="Serviço de enfermagem"
    >
        <Form
            :data="data"
            @save="handleExit"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    methods: {
        open() {

            this.$refs.Modal.show()
        },
        handleExit(data) {

            this.$emit('save', data)

            this.$refs.Modal.hide()
        },
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>